export default __webpack_public_path__ + "static/media/p6.11fe499b.jpg";